module.exports = __webpack_public_path__ + "img/project_filter.c95f949c.svg";